import MuiSkeleton, {
    SkeletonProps as MuiSkeletonProps
} from '@mui/material/Skeleton';
import * as React from 'react';

export const Skeleton = (props: MuiSkeletonProps) => {
    return (
        <MuiSkeleton
            data-role="skeleton"
            {...props}
            sx={{
                ...(props.variant !== 'circular' && { borderRadius: 1 }),
                backgroundColor: (theme) =>
                    props?.color ?? theme.palette.action.hover,
                ...props.sx
            }}
        />
    );
};
